import React from "react";
import './CaseStudies.css';
import J1 from "../img/J1.png";
import J2 from "../img/J2.png";
import J3 from "../img/J3.png";
import J4 from "../img/J4.png";
import ishikawa from "../img/石川県.png";

const CaseStudies = () => {
    const cases = [
        {
            id: 1,
            icon: J1,
            company: '飲食店A様',
            location: '金沢市内',
            testimonial: 'Googleマップからの問い合わせが増えました。丁寧なレポートで効果が見えます。'
        },
        {
            id: 2,
            icon: J2,
            company: '動物病院B様',
            location: '野々市市',
            testimonial: '月三万円の広告費で、予約が2倍になりました。対面で相談できるので安心です。'
        },
        {
            id: 3,
            icon: J3,
            company: '土業C様',
            location: '金沢市内',
            testimonial: '専門用語をかみ砕いて説明してくれるので、広告初心者でも安心でした。'
        },
        {
            id: 4,
            icon: J4,
            company: '小売店D様',
            location: '小松市',
            testimonial: '地域特化だからこそ、金沢ならではのキーワードで集客できています。'
        }
    ];

    return (
        <section className="case-studies">

            <div className="ishikawa-map"><img src={ishikawa} /></div>

            <div className="case-studies-container">
                <h2 className="case-studies-title">導入事例</h2>
                
                <div className="cases-grid">
                    {cases.map((caseItem) => (
                        <div key={caseItem.id} className="case-card">
                            <div className="case-card-content">
                                <div className="case-icon">
                                    <img src={caseItem.icon} alt={caseItem.company} />
                                </div>
                                <div className="case-info">
                                    <h3 className="case-company">
                                        {caseItem.company}
                                        <span className="case-location">（{caseItem.location}）</span>
                                    </h3>
                                    <div className="case-testimonial">
                                        <span className="quote-mark">"</span>
                                        {caseItem.testimonial}
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default CaseStudies;
